
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import HowToPay from '../pages/how-to-pay/page';
import BankDetails from '../pages/bank-details/page';
import Deadlines from '../pages/deadlines/page';
import Contact from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/how-to-pay',
    element: <HowToPay />,
  },
  {
    path: '/bank-details',
    element: <BankDetails />,
  },
  {
    path: '/deadlines',
    element: <Deadlines />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
